import React, { useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./Slider.scss";
import BusinessContext from "context/BusinessContext";
import FindMediaSrc from "components/common/FindMediaSrc";

const Slider = ({ product }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  let src = FindMediaSrc(product);
  let loop;
  if (src.length < 3) loop = false;
  else loop = true;
  return (
    <>
      <div className="row slider sliderSingleProduct">
        <div className="col-12 col-md-8 col-xxl-7 slide1">
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            navigation={true}
            loop={loop}
            spaceBetween={10}
            allowTouchMove={true}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper2"
          >
            {src.map((value, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="slideContent">
                    <div className="image">
                      <img src={value.src} alt="image" />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className="d-none d-sm-block col-md-4 slide2">
          <Swiper
            onSwiper={setThumbsSwiper}
            loop={loop}
            allowTouchMove={true}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            breakpoints={{
              slidesPerView: 1,
              spaceBetween: 10,
              direction: "horizortal",
              480: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
                direction: "vertical",
              },
            }}
            // direction={"vertical"}
            className="mySwiper"
          >
            {src.map((value, index) => {
              return (
                <SwiperSlide key={index}>
                  <img src={value.src} alt="image" />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Slider;
